import { camActionTypes } from '../../components/common/utilities/playBackControls/camActionTypes';

export const WEATHERCAM_TIME_LAPSE_CONTROL_ACTION = 'WEATHERCAM_TIME_LAPSE_CONTROL_ACTION';

export function weatherCamTimeLapseControlAction(currentTimeLapseImageIndex, timelapseAction) {

    let timelapsePlayerInitiated = true;

    if(timelapseAction === camActionTypes.stop){
        timelapsePlayerInitiated = false;
    }

    const result = {
        timelapsePlayerInitiated,
        currentTimeLapseImageIndex,
        timelapseAction
    };

    return {
        type: WEATHERCAM_TIME_LAPSE_CONTROL_ACTION,
        payload: result
    };
};

